import { render, staticRenderFns } from "./Sugeridos.vue?vue&type=template&id=263ed343&"
import script from "./Sugeridos.vue?vue&type=script&lang=js&"
export * from "./Sugeridos.vue?vue&type=script&lang=js&"
import style0 from "./Sugeridos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports